import React from 'react';
import { BarChart3, ArrowLeft } from 'lucide-react';

// Usar URL relativa o variable de entorno sin fallback a localhost
import { API_CONFIG } from '../../../config/constants';

const LoginView = ({
  credentials,
  setCredentials,
  handleLogin,
  onBack
}: {
  credentials: { email: string; password: string; domain: string };
  setCredentials: React.Dispatch<React.SetStateAction<{ email: string; password: string; domain: string }>>;
  handleLogin: () => void;
  onBack?: () => void;
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-600 to-sky-800 flex items-center justify-center p-4">
      <div className="bg-slate-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="bg-sky-600 p-8 text-center">
          <div className="w-16 h-16 bg-white rounded-full mx-auto mb-4 flex items-center justify-center">
            <BarChart3 className="w-8 h-8 text-sky-600" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">AION BI</h1>
          <p className="text-sky-100">Dashboard System MVP</p>
        </div>
        
        <div className="p-8">
          <h2 className="text-2xl font-bold text-white mb-6">Iniciar Sesión</h2>
          
          <div className="space-y-4">
            <div>
              <label className="text-slate-300 text-sm mb-2 block">Correo Electrónico</label>
              <input
                type="email"
                value={credentials.email}
                onChange={(e) => setCredentials({...credentials, email: e.target.value})}
                placeholder="usuario@ejemplo.com"
                className="w-full bg-slate-700 text-white rounded-lg px-4 py-3 focus:ring-2 focus:ring-sky-500 outline-none"
              />
            </div>
            
            <div>
              <label className="text-slate-300 text-sm mb-2 block">Contraseña</label>
              <input
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                placeholder="••••••••"
                className="w-full bg-slate-700 text-white rounded-lg px-4 py-3 focus:ring-2 focus:ring-sky-500 outline-none"
              />
            </div>
          </div>

          <div className="mt-4">
            <label className="text-slate-300 text-sm mb-2 block">Dominio</label>
            <input
              type="text"
              value={credentials.domain || ''}
              onChange={(e) => setCredentials({...credentials, domain: e.target.value})}
              placeholder="Escribe el dominio"
              className="w-full bg-slate-700 text-white rounded-lg px-4 py-3 focus:ring-2 focus:ring-sky-500 outline-none"
            />
          </div>
          <button
            onClick={handleLogin}
            className="w-full bg-sky-500 hover:bg-sky-600 text-white font-semibold py-3 rounded-lg mt-6 transition-colors"
          >
            Iniciar Sesión
          </button>

          {/* Divider */}
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-slate-700"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-4 bg-slate-800 text-slate-400">o continúa con</span>
            </div>
          </div>

          {/* Google OAuth Button */}
          <button
            onClick={() => {
              // ✅ FIXED: Usar la ruta correcta /api/auth/google
              const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:4000';
              window.location.href = `${backendUrl}/api/auth/google`;
            }}
            className="w-full bg-white hover:bg-gray-50 text-gray-700 font-semibold py-3 rounded-lg transition-colors flex items-center justify-center gap-3 border border-gray-300"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continuar con Google
          </button>

          {onBack && (
            <button
              onClick={onBack}
              className="w-full mt-3 text-slate-400 hover:text-sky-400 font-medium py-2 transition-colors flex items-center justify-center gap-2"
            >
              <ArrowLeft className="w-4 h-4" />
              Volver a inicio
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginView;
